exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav ul {\n  list-style-type: none;\n  margin: 0 auto 0px auto;\n  padding: 0;\n  width: 100%;\n}\n\n.nav ul li {\n  display: inline-block;\n  margin: 20px auto;\n  padding: 10px;\n  text-align: center;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n  width: 33%;\n}\n\n.link-box {\n  margin: 0 auto;\n  -webkit-transition: 0.2s;\n  transition: 0.2s;\n  width: 33%;\n}\n\n.link-box:hover span:last-child {\n  padding-bottom: 5px;\n  background-color: transparent;\n  text-decoration: none;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n}\n\nfa {\n  margin-bottom: 10px;\n  padding-left: 10px;\n}\n\n.large-fa-icon {\n  font-size: 44px;\n}\n\n/* responsive styles */\n\n@media screen and (min-width: 1500px) {\n  .nav {\n    margin-top: 150px;\n  }\n}\n\n@media screen and (max-width: 860px) {\n  .nav ul li {\n    margin: 0px auto;\n    width: 31%;\n  }\n}\n\n@media screen and (max-width: 550px) {\n  .large-fa-icon {\n    font-size: 52px;\n  }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/abeltrotter/Documents/git/epicodus/javascript/portfolio-angular/src/app/navbar/navbar.component.css
// module id = ../../../../../src/app/navbar/navbar.component.css
// module chunks = main